import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';

import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';
import {SpcChoiceAttribute} from './spcChoiceAttribute';

@customElement('spc-choice-attribute-color')
export class SpcChoiceAttributeColor extends SpcChoiceAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			.attribute {
				break-inside: avoid;
			}
		`];

	render() {
		if (!this.values) return null;
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<span class="label">
						<trans-label key="${this.attributeId.localId}" context="F" title="${this.attributeId.localId}"></trans-label>
					</span>
					<div class="tools">
						${when(this.hasFeatureDescription(), () => html`
							<button class='tools_button' @click="${this.openModal}">${info}</button>
						`)}
						<div class="status">
							${when(!this.isMandatory(), () => html`
								<button class='tools_button reset' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
							`)}
							<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
						</div>
					</div>
				</div>
				<div class="values">
					${repeat(this.values,
						(value) => value.id,
						(value) => html`
							<spc-choice-value-color
								.attributeId=${this.attributeId}
								.value=${value}
								.hideWhenDisabled=${this.hideDisabledValues}
								.productData=${this.getProductDataForValue(value.id)}>
							</spc-choice-value-color>
						`)}
				</div>
			</div>
		`;
	}
}
